import { For } from "solid-js";
import clsx from "~/util/html/style";
import type { Step } from "./types";

type StepDef = { id: Step; label: string };

export function StepIndicator(props: { steps: StepDef[]; currentStep: Step }) {
  const currentIndex = () => props.steps.findIndex((s) => s.id === props.currentStep);

  return (
    <div class="flex items-center gap-2">
      <For each={props.steps}>
        {(stepDef, index) => {
          const state = () => {
            const ci = currentIndex();
            if (index() < ci) return "completed";
            if (index() === ci) return "current";
            return "upcoming";
          };

          return (
            <>
              <div
                class={clsx(
                  "flex size-7 items-center justify-center rounded-full text-xs font-semibold transition-colors",
                  state() === "completed" && "bg-brand-primary text-white",
                  state() === "current" &&
                    "bg-brand-primary text-white ring-2 ring-brand-primary/30",
                  state() === "upcoming" && "bg-brand-subtle text-typography-secondary",
                )}
              >
                {state() === "completed" ? (
                  <svg
                    class="size-3.5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="3"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  index() + 1
                )}
              </div>
              {index() < props.steps.length - 1 && (
                <div
                  class={clsx(
                    "h-px flex-1",
                    index() < currentIndex() ? "bg-brand-primary" : "bg-brand-subtle",
                  )}
                />
              )}
            </>
          );
        }}
      </For>
    </div>
  );
}
